import axios from '../services/request'

/* 阅读在线 */
export const Read = (data = {}) => axios.post('api/questionbank/read',data);

/* 阅读在线详情查看 */
export const readDetail = (data = {}) => axios.get('api/questionbank/readDetail',data);

/* 应试英语题型 */
export const specialtyQuestion = (data = {}) => axios.get('api/questionbank/specialtyQuestion',data);

/* 应试英语 */
export const specialtyList = (data = {}) => axios.post('api/questionbank/specialtyList',data);

/* 应试英语详情 */
export const specialtyDetail = (data = {}) => axios.get('api/questionbank/specialtyDetail',data);

/* 创建自建题库目录 */
export const createDirectory = (data = {}) => axios.post('api/questionbank/createDirectory',data);

/* 创建自建题库目录 */
export const directory = (data = {}) => axios.get('api/questionbank/directory',data);

/* 添加材料 */
export const createQuestion = (data = {}) => axios.post('api/questionbank/createQuestion',data);

/* 添加材料 */
export const material = (data = {}) => axios.get('api/questionbank/material',data);

/* 验证材料题量 */
export const verifyQuestion = (data = {}) => axios.post('api/questionbank/verifyQuestion',data);


export default{
    Read,
    readDetail,
    specialtyQuestion,
    specialtyList,
    specialtyDetail,
    createDirectory,
    directory,
    createQuestion,
    material,
    verifyQuestion
}